export default __webpack_public_path__ + "static/rama-3aba75c9c081f45ec7a7d8b0e50b5599.png";